import React from 'react'

import { HIWCat1, HIWCat2, HIWCat3 } from '../../../../assets/svgs/landingV2/guest'
import './styles.scss'
import './responsiveStyles.scss'

function HowItWorks() {
  return (
    <div className='gl_hiw'>
      <div className='gl_hiw__title'>
        <h1>Як це працює?</h1>
      </div>
      <div className='gl_hiw__info'>
        <div className='gl_hiw__info_item'>
          <div className='gl_hiw__info_item_logo'>
            <img src={HIWCat1} alt='Cat 1' />
          </div>
          <div className='gl_hiw__info_item_title'>
            <h5>01/</h5>
            <h6>Зареєструйся</h6>
          </div>
          <div className='gl_hiw__info_item_desc'>
            <p>Завантажуй застосунок Pinka, легко заходь по номеру телефону без довгих реєстрацій.</p>
          </div>
        </div>
        <div className='gl_hiw__info_item'>
          <div className='gl_hiw__info_item_logo'>
            <img src={HIWCat2} alt='Cat 2' />
          </div>
          <div className='gl_hiw__info_item_title'>
            <h5>02/</h5>
            <h6>Зроби замовлення</h6>
          </div>
          <div className='gl_hiw__info_item_desc'>
            <p>Обери кав&apos;ярню, переглянь меню, сформуй замовлення і отримуй його статус в реальному часі.</p>
          </div>
        </div>
        <div className='gl_hiw__info_item'>
          <div className='gl_hiw__info_item_logo'>
            <img src={HIWCat3} alt='Cat 3' />
          </div>
          <div className='gl_hiw__info_item_title'>
            <h5>03/</h5>
            <h6>Насолоджуйся</h6>
          </div>
          <div className='gl_hiw__info_item_desc'>
            <p>Отримай замовлення в баристи, без черг і очікувань. Смачного!</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HowItWorks
